export enum RainbowColor {
  Rose = 'rose',
  Pink = 'pink',
  Purple = 'purple',
  Lilac = 'lilac',
  Ocean = 'ocean',
  Emerald = 'emerald',
  Forest = 'forest',
  Olive = 'olive',
  Wood = 'wood',
  Leather = 'leather',
}
